class ProfileApi {
    constructor(axios) {
        this.axios = axios;
    }
    postUpdate(formData, callback) {
        return this.axios.post(`/api/profile`, formData);
    }
    postProfilePicture(formData, callback) {
        return this.axios.post(`/api/profile_picture`, formData);
    }
}
class SubscriptionApi {
    constructor(axios) {
        this.axios = axios;
    }
    postCreateSubscriptionAction(formData, callback) {
        return this.axios.post(`/api/user/module-subscription`, formData);
    }
    postUpdateIsUnsubscribeAction(formData, callback) {
        return this.axios.post(`/api/user/update-is-unsubscribe`, formData);
    }
    postValidateVoucherCodeAction(formData, callback) {
        return this.axios.post(`/api/user/validate-voucher-code`, formData);
    }
    postUpdateUserNextProductSubscription(formData, callback) {
        return this.axios.post(`/api/user/update-user-next-package-subscription`, formData);
    }
    postEditActiveProductSubscription(formData, callback) {
        return this.axios.post(`/api/admin/subscription-edit`, formData);
    }
    postCreateSubscriptionPackage(formData, callback) {
        return this.axios.post(`/api/user/package-subscription`, formData);
    }
}
class UserApi {
    constructor(axios) {
        this.axios = axios;
    }
    postUpdateSubscription(formData, callback) {
        return this.axios.post(`/api/user/update-subscription`, formData);
    }
    postValidateEmailAction(formData, callback) {
        return this.axios.post(`/api/user/email-exist`, formData);
    }
}
class AdminApi {
    constructor(axios) {
        this.axios = axios;
    }
    postEditUserSubscriptionInfo(userApiId, formData, callback) {
        return this.axios.post(`/api/admin/users/${userApiId}/subscription`, formData);
    }
    postAddDiscountRequest(userId, formData, callback) {
        return this.axios.post(`/api/admin/users/${userId}/discount-request`, formData);
    }
    postSendPaymentLinkEmail(userId, formData, callback) {
        return this.axios.post(`/api/admin/users/${userId}/send-payment-link-email`, formData);
    }
}
class MollieApi {
    constructor(axios) {
        this.axios = axios;
    }
    getUserMandateStatus(userId, formData) {
        return this.axios.get(`/api/admin/mollie/user-mandate-status/${userId}`, {params: formData});
    }
}
class ResetPasswordApi {
    constructor(axios) {
        this.axios = axios;
    }
    postForgotPassword(formData, callback) {
        return this.axios.post(`/api/password/forget`, formData);
    }
}
class AuthApi {
    constructor(axios) {
        this.axios = axios;
    }
    postRegister(formData, callback) {
        return this.axios.post(`/api/register`, formData);
    }
}

export default class Api {
    constructor(axios) {
        this.axios = axios;
        this.profile = new ProfileApi(this.axios);
        this.subscription = new SubscriptionApi(this.axios);
        this.user = new UserApi(this.axios);
        this.admin = new AdminApi(this.axios);
        this.mollie = new MollieApi(this.axios);
        this.resetPassword = new ResetPasswordApi(this.axios);
        this.auth = new AuthApi(this.axios);
    }
}


// WEBPACK FOOTER //
// ./resources/js/api.js